<template>
<!-- 拼团 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="add-box">
            <router-link to="/main/Edit_spell_group">
                <el-button type="primary" size="medium">创建拼团</el-button>
            </router-link>
            <!--  -->
            <div class="search">
                <el-select class="search-child" v-model="state" placeholder="请选择状态" clearable>
                    <el-option  label="开启" :value="1">开启</el-option>
                    <el-option  label="关闭" :value="2">关闭</el-option>
                </el-select>
                <!--  -->
                <el-select class="search-child" v-model="status" placeholder="请选择类型" @change="courseTypeHandle" clearable>
                    <el-option v-for="(item,index) in course_list" :key="index"  :label="item.name" :value="item.id">{{item.name}}</el-option>
                </el-select>
                <!--  -->
                <el-select class="search-child"  v-model="bid" placeholder="请选择课程"  @click.native="courseNameHandle"  filterable clearable>
                    <el-option v-for="(item,index) in course_list2" :key="index"  :label="item.name" :value="item.id">{{item.name}}</el-option>
                </el-select>
                <!-- 搜索 -->
                <el-button type="primary" class="search-child" @click="pullData" round  size="medium">搜索</el-button>
            </div>
            
        </div>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="100" label="序号"></el-table-column>
                <el-table-column prop="coursename" label="课程名称" ></el-table-column>
                <el-table-column prop="statusname" label="课程类型"></el-table-column>
                <el-table-column prop="num" label="成团人数" > </el-table-column>
                <el-table-column prop="price" label="拼团价格" > </el-table-column>
                <el-table-column prop="create_count" label="开团数" > </el-table-column>
                <el-table-column prop="success_count" label="成团数" > </el-table-column>
                <el-table-column  label="状态">
                    <template slot-scope="scope">
                        <el-tag size="small" v-if="scope.row.state==1" type="success">开启</el-tag>
                        <el-tag size="small" v-if="scope.row.state==2"  type="info">关闭</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="180"  label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.$index, scope.row,'edit')" circle></el-button>
                        <el-button  icon="el-icon-view" size="mini"  
                            @click="$router.push({
                                path:'spell_group_list',
                                query:{
                                    id:scope.row.id
                                }
                            })" circle>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { scrabble_list } from "@/api/operating";
export default {
    data() {
        return{
            pages:{},
            list:[],
            // 
            bid:null,
            state:null,
            status:null,
            // 所有课程列表
            course_list:[],
            course_list2:[],
            obj:{}
        }
    },
    methods:{
        /*
         *@Description: 课程名称
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-14 16:13:27
        */
        courseNameHandle(){
            if(!this.status){
                this.$message({
                    message: '课程类型不能为空',
                    type: 'warning'
                });
                return;
            }
        },
        /*
         *@Description: 课程类型
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-14 16:03:06
        */
        courseTypeHandle(value){
            this.course_list.forEach((item,index)=>{
                if(item.id==this.status){
                    this.course_list2 = item.list;
                }
            });
        },
        edit(index,row){
            this.$router.push({
                path:'/main/Edit_spell_group',
                query:{
                    id:row.id,
                    type:'edit'
                }
            });
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            if(this.state){
                this.obj['state'] = this.state;
            }
            if(this.status){
                this.obj['status'] = this.status;
            }

            if(String(this.bid)){
                this.obj['bid'] = this.bid;
            }

            scrabble_list(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;

                // 
                this.course_list = data.statuslist;

                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.add-box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    margin-left: auto;
    text-align: right;
}
.search-child{
    margin-left: 20px;
}
</style>
